<template>
<v-dialog v-model="showDialog" max-width="900" @click:outside="cancelDialog">
  <v-card class="pa-10">
    <v-card-title class="justify-center mb-6">
      <h3>Choose key</h3>
    </v-card-title>

    <v-select
      class="mr-10 ml-10"
      item-text="Title"
      :items="userSSHKeys"
      return-object
      v-model="selectedSSHKey"
      label="Select SSH key"
      append-icon="fas fa-caret-down"
      hide-details
    ></v-select>

    <v-card-actions class="justify-center mt-12">
      <v-btn text @click="cancelDialog">
        Close
      </v-btn>
      <v-btn text @click="confirmDialog" :disabled="!selectedSSHKey">
        Confirm
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      selectedSSHKey: false
    };
  },
  props: ["show", "userSSHKeys"],
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value)
      } 
    }
  },
  methods: {
    cancelDialog() {
      this.selectedSSHKey = "";
      this.showDialog = false;
    },
    confirmDialog() {
      this.$emit("confirmDialog", this.selectedSSHKey);
      this.selectedSSHKey = "";
    }
  },
  created() {
    this.selectedSSHKey = "";
  }
};
</script>

<style scoped>
</style>
